import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  TransactionFeeController.$inject = ["API_URL", "ADMIN_URL", "$rootScope", "$http", "$timeout", "jwtHelper", "$location"];
  angular.module('userApp').controller('TransactionFeeController', TransactionFeeController);

  function TransactionFeeController(API_URL, ADMIN_URL, $rootScope, $http, $timeout, jwtHelper, $location) {
    var tran = this;
    tran.isOwner = false;
    $rootScope.$watch('userInfo', function () {
      if ($rootScope.userInfo) {
        tran.userInfo = $rootScope.userInfo;
        tran.isOwner = false;
        tran.userInfo.roles.forEach(function (role) {
          if (role.type === 'OWNER') {
            tran.isOwner = true;
          }
        });
      }
    });
    tran.doConsent =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _ref2, data, token, payload;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              $rootScope.throbber.show();
              _context.prev = 1;
              $rootScope.throbber.hide();
              _context.next = 5;
              return $http.put(API_URL + '/api/v1/settings/organisation/transaction-fee-consent/true');

            case 5:
              _ref2 = _context.sent;
              data = _ref2.data;
              token = data.token;
              payload = jwtHelper.decodeToken(token);
              tran.loading = false;
              $rootScope.userInfo = payload.user;
              localStorage.setItem('jwt-token', token);
              $location.path('/dashboard');
              $rootScope.safeApply();
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](1);
              console.error(_context.t0.message);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 16]]);
    }));
    tran.disableCharging =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var _ref4, data, token, payload;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (confirm('This will disable charging for your organisation. You will retain access to all the other features of Smoothbook. Continue?')) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              tran.loading = true;
              _context2.prev = 3;
              _context2.next = 6;
              return $http.put(API_URL + '/api/v1/settings/organisation/transaction-fee-consent');

            case 6:
              _ref4 = _context2.sent;
              data = _ref4.data;
              token = data.token;
              payload = jwtHelper.decodeToken(token);
              tran.loading = false;
              $rootScope.userInfo = payload.user;
              localStorage.setItem('jwt-token', token);
              $location.path('/dashboard');
              $rootScope.safeApply();
              _context2.next = 20;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](3);
              console.error(_context2.t0.message);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[3, 17]]);
    }));
  }
})();